import { trimStart } from "lodash";
import { parse } from "qs";
import { getSearch } from "./global";

/**
 * 获取搜索数据
 */
export function getSearchData(trackData: Record<string, any> = {}) {
  const params = parse(trimStart(location.search, "?"));
  const searchData = getSearch();

  trackData.search_word = params.q;
  trackData.search_word_type = searchData.search_word_type;
  trackData.filter_ids = searchData.filter_ids || [];
  trackData.original_search_word = searchData.original_search_word;
  trackData.top_label_list = searchData.top_label_list || [];
  trackData.top_label_depth = searchData.top_label_depth || 0;

  return trackData;
}
